export default __webpack_public_path__ + "static/media/captur-colour-3.e2a5262b.jpg";